export default __webpack_public_path__ + "assets/samcon.8598f8cf.webp";